import { render, staticRenderFns } from "./searchInput.vue?vue&type=template&id=640d9601&"
import script from "./searchInput.vue?vue&type=script&lang=js&"
export * from "./searchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/searchInput.vue"
export default component.exports